"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.QuestionTabs = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _QuestionTabs = require("./QuestionTabs.styled");
var _helpers = require("../../../helpers");
var _constants = require("../../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var tabs = [{
  name: _constants.QUESTIONS_OPEN_TYPE,
  emptyString: _constants.QUESTION_TAB_EMPTY_STRING_OPEN
}, {
  name: _constants.QUESTIONS_ANSWERED_TYPE,
  emptyString: _constants.QUESTION_TAB_EMPTY_STRING_ANSWERED
}, {
  name: _constants.QUESTIONS_ARCHIVED_TYPE,
  emptyString: _constants.QUESTION_TAB_EMPTY_STRING_ARCHIVED
}];
var getTab = function getTab(tabName) {
  return tabs.find(function (x) {
    return x.name === tabName;
  });
};
var QuestionTabs = exports.QuestionTabs = function QuestionTabs(_ref) {
  var _getTab;
  var onTabChanged = _ref.onTabChanged,
    _ref$questions = _ref.questions,
    questions = _ref$questions === void 0 ? [] : _ref$questions,
    _ref$currentTab = _ref.currentTab,
    currentTab = _ref$currentTab === void 0 ? _constants.QUESTIONS_OPEN_TYPE : _ref$currentTab,
    _ref$showArchived = _ref.showArchived,
    showArchived = _ref$showArchived === void 0 ? true : _ref$showArchived,
    _ref$showDefaultText = _ref.showDefaultText,
    showDefaultText = _ref$showDefaultText === void 0 ? true : _ref$showDefaultText;
  var _useState = (0, _react.useState)(currentTab),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var toggleTab = function toggleTab(tab) {
    if (activeTab !== tab) setActiveTab(tab);
    if (!!onTabChanged) onTabChanged(tab);
  };
  var TabsNotice = function TabsNotice(_ref2) {
    var tabNoticeString = _ref2.tabNoticeString,
      displayTabsNotice = _ref2.displayTabsNotice;
    if (!displayTabsNotice) return null;
    return /*#__PURE__*/_react["default"].createElement(_QuestionTabs.StyledTabsNotice, {
      "data-testid": "tabs-notice"
    }, tabNoticeString);
  };
  return /*#__PURE__*/_react["default"].createElement(_QuestionTabs.Tabs, null, /*#__PURE__*/_react["default"].createElement(_QuestionTabs.TabsList, {
    tabs: true,
    className: 'row mx-0'
  }, tabs.map(function (_ref3) {
    var tabName = _ref3.name;
    if (tabName === _constants.QUESTIONS_ARCHIVED_TYPE && !showArchived) return;
    return /*#__PURE__*/_react["default"].createElement(_QuestionTabs.Tab, {
      "data-testid": tabName,
      key: tabName,
      isActive: activeTab === tabName,
      onClick: function onClick() {
        return toggleTab(tabName);
      },
      className: 'col'
    }, (0, _helpers.titleCaseWords)(tabName));
  })), showDefaultText && /*#__PURE__*/_react["default"].createElement(TabsNotice, {
    tabNoticeString: (_getTab = getTab(activeTab)) === null || _getTab === void 0 ? void 0 : _getTab.emptyString,
    displayTabsNotice: !questions.length
  }));
};
QuestionTabs.propTypes = {
  onTabChanged: _propTypes["default"].func,
  questions: _propTypes["default"].array,
  currentTab: _propTypes["default"].string,
  showDefaultText: _propTypes["default"].bool
};
var _default = exports["default"] = QuestionTabs;